import { Mail, Loader2 } from 'lucide-react';
import { AdminPageHeader, StatCard, useFetcher } from './_P1Common';

export default function AdminNewsletterDigest() {
  const { data, loading } = useFetcher('newsletter-digest');
  if (loading || !data) return <AdminPageHeader icon={Mail} title="Sažetak newslettera"><Loader2 className="animate-spin"/></AdminPageHeader>;
  return (
    <div data-testid="admin-newsletter-digest">
      <AdminPageHeader icon={Mail} title="Sažetak newslettera" subtitle="Prijedlog sadržaja za tjedni newsletter"/>
      <div className="px-4 md:px-6 grid grid-cols-2 md:grid-cols-3 gap-3 mb-6">
        <StatCard testid="nd-subs" label="Potvrđenih pretplatnika" value={data.subscribers} accent="green"/>
        <StatCard testid="nd-top-count" label="Broj preporučenih" value={(data.top || []).length} accent="blue"/>
      </div>
      <div className="px-4 md:px-6 pb-6 mx-0 md:mx-6 border border-zinc-800 rounded-lg">
        <h3 className="px-4 py-2 border-b border-zinc-800 font-bold text-sm">Top 10 članaka proteklog tjedna</h3>
        <ul className="divide-y divide-zinc-800">
          {(data.top || []).map(a => (
            <li key={a.id} className="px-4 py-2 flex items-center gap-3 text-sm">
              {a.featured_image && <img src={a.featured_image} alt="" className="w-10 h-10 object-cover rounded"/>}
              <div className="flex-1 min-w-0">
                <a href={`/clanak/${a.slug}`} target="_blank" rel="noreferrer" className="truncate block hover:text-red-400">{a.title}</a>
                <span className="text-xs text-zinc-500">{a.category || '—'}</span>
              </div>
              <span className="text-red-400 text-xs">{a.views || 0}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
